import Link from "next/link";
import { Variables } from "./Variables";
import triggerIcon from "../../../../new-images/profile/trigger-icon.svg";

export const useEmailUnavaibleVariables = (email) => {

  return new Variables(
    {
      title: (
        <>Ваш email <b>{email}</b> сейчас недоступен для рассылок.</>
      ),
      img: triggerIcon,
      prompt: (
        <span>Мы не присылаем много писем. Давайте будем на связи!</span>
      ),
      label: (
        <>Чтобы быть в курсе событий донорства, подтвердите согласие на рассылки или <Link href="/profile/settings/general/">обновите email</Link> на актуальный.</>
      ),
      button: "Подтвердить согласие на рассылки",
      buttonHide: "Скрыть"
    },
  )
};
